import {useEffect, useRef} from 'react';
import {requestContext} from '../../../../../../common/requestContext';
import useTypedSelector from '../../../../../../common/useTypedSelector';

export default function useWatermark() {
  const user = useTypedSelector(state => state.user.user);
  const animationFrameHandleRef = useRef(0);
  useEffect(() => {
    function checkAndAddWaterMark() {
      if (!document.getElementById(CONTAINER_ID)) {
        const deviceId = requestContext.requestInfo.deviceId;
        const requestId = requestContext.requestInfo.requestId;

        const container = document.createElement('div');
        container.id = CONTAINER_ID;

        // 같은 곳에 계속 노출하면 글자가 보이는 효과(burn-in 효과)가 있다고 해서 top을 랜덤으로 지정
        const top = Math.random() * 50;
        container.style.cssText = `position:fixed; left:0; top:${top}px; bottom:0; padding:0 10%; width:100%; opacity:0.004; display:flex; flex-direction:column; justify-content:space-between; font-size:14px; z-index:40; pointer-events:none;`;

        if (requestContext.requestInfo.display.isMobile) {
          for (let i = 0; i < 10; i++) {
            const div = document.createElement('div');
            div.style.cssText =
              'width:100%; display:flex; justify-content:center;';

            const k = i % 3;

            const span = document.createElement('span');
            span.style.cssText =
              'font-weight:bold; color:' +
              (k === 0 ? 'red' : k === 1 ? 'green' : 'blue');

            span.textContent = i % 3 === 0 ? deviceId : requestId;
            div.appendChild(span);

            container.appendChild(div);
          }
        } else {
          for (let i = 0; i < 10; i++) {
            const div = document.createElement('div');
            div.style.cssText =
              'width:100%; display:flex; justify-content:space-between;';
            for (let k = 0; k < 3; k++) {
              const span = document.createElement('span');
              span.style.cssText =
                'font-weight:bold; color:' +
                (k === 0 ? 'red' : k === 1 ? 'green' : 'blue');
              span.textContent = (i + k) % 3 === 0 ? deviceId : requestId;
              div.appendChild(span);
            }
            container.appendChild(div);
          }
        }

        document.body.appendChild(container);
      }
      animationFrameHandleRef.current =
        requestAnimationFrame(checkAndAddWaterMark);
    }

    const prevContainer = document.getElementById(CONTAINER_ID);
    if (prevContainer) {
      cancelAnimationFrame(animationFrameHandleRef.current);
      document.body.removeChild(prevContainer);
    }
    animationFrameHandleRef.current =
      requestAnimationFrame(checkAndAddWaterMark);
    return () => {
      cancelAnimationFrame(animationFrameHandleRef.current);
    };
  }, [user]);
}

const CONTAINER_ID = 'kp-marker';
